import { NgModule } from '@angular/core'
import { ConfigInitializerService } from '@spartacus/core'
import { EbConfigInitializerService } from './eb-config-initializer.service'

@NgModule({
  providers: [
    {
      provide: ConfigInitializerService,
      useExisting: EbConfigInitializerService
    }
  ]
})
export class EbConfigInitializerModule {}
